import PaasHeader from '../PaasHeader';
import PaasNavigation from '../PaasNavigation';
import PaasSearchOverlay from '../PaasSearchOverlay';

const WebdienstHeader: React.FC = () => {
  return (
    <>
      <nav className="paas navbar navbar-light navbar-expand-lg navbar-main">
        <PaasHeader />
        <PaasNavigation />
      </nav>

      <PaasSearchOverlay />
    </>
  );
};

export default WebdienstHeader;
